/*
    Create by fanglijuan 2017-05-25
*/
'use strict';
angular.module("moveAccountSynchroToGroupModule", [])
    .controller("moveAccountSynchroToGroupCtrl", ["$scope", "$location", "$stateParams", "$q", "$filter", "$timeout", "$modalInstance", "trsHttpService", 'treeService', "$state", "$validation", "trsspliceString", "globleParamsSet", "accountSynchroToGroupService", "modalDialog", "item",'nameChange',
        function($scope, $location, $stateParams, $q, $filter, $timeout, $modalInstance, trsHttpService, treeService, $state, $validation, trsspliceString, globleParamsSet, accountSynchroToGroupService, modalDialog, item,nameChange) {
            initStatus();
            initData();

            function initStatus() {
                $scope.status = {
                    groupName: item.DEPARTNAME,
                    synGroupId: item.SYNGROUPID,
                    parentId: item.PRAENTID,
                    departId: item.DEPARTID,
                };
                $scope.data = {
                    globalName:nameChange.globalName,
                    modalTitle: "组织同步",
                    "navTitle": "移动",
                    currMLFGroup: [],
                };
            }
            /**
             * [initData description]初始化数据
             */
            function initData() {
                getYPGroupDetail();
            }

            //获取媒立方对应的8531信息
            function getYPGroupDetail() {
                var params = {
                    "serviceid": "mlf_groupmanagement",
                    "methodname": "getYPGroupDetail",
                    "SynGroupId": $scope.status.synGroupId,
                    /*"DepartId": $scope.status.departId,*/
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    $scope.data.currMLFGroup = data;
                });
            }

            //移动：点击确定
            $scope.confirm = function() {
                var params = {
                    serviceid: "mlf_groupmanagement",
                    methodname: "moveToBaseMLFGroup",
                    FromGroupIds: $scope.data.currMLFGroup.MLFGROUPID,
                    ToGroupId: $scope.data.currMLFGroup.SYNPARENTID,
                    SynGroupId: $scope.status.synGroupId,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                    /*modalDialog.alertType("同步成功", "", "success", false, function() {
                        $modalInstance.close('success');
                    });*/
                    var res = data.ISSUCCESS == 'true' ? 'success' : 'error';
                    modalDialog.alertType(data.DETAIL, "", res, false, function() {
                        $modalInstance.close();
                    });
                });
            };
            //取消
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
        }
    ]);
